export const getBackendBaseUrl = () => {
  const raw = process.env.REACT_APP_BACKEND_URL || "";

  // remove trailing slash
  let base = raw.endsWith("/") ? raw.slice(0, -1) : raw;

  // remove /api or /api/v1 if present
  base = base.replace(/\/api(\/v\d+)?$/, "");

  return base;
};
